module.exports = __webpack_public_path__ + "558209b.woff2";